import React, { useState, useEffect } from 'react'
import io from "socket.io-client";
import '../styles/styles.css'
import VideoChat from './VideoChat'
import '../styles/chat.css'
import { config } from '../server'
import {Link} from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react';
const address = config.url.API_URL


let socket = io.connect('https://clusterfy.herokuapp.com');

const Chat = (props) => {
    const person = props.match.params.person
    const [messages, setMessages] = useState([""]);
    const [message, setMessage] = useState("");
    const [requested, setRequest] = useState(false)
    const [tutorInfo, setTutorInfo] = useState({})
    const { user, isAuthenticated, isLoading } = useAuth0();
    const [name, setName] = useState('')


  useEffect(() => {
    const getName = async () => {
			const response = await fetch(address + `/api/${user.email}/getUser`)
        	const data1 = await response.json()
			setName(data1.name)
		}
    getName()
    const getTutorInfo = async () => {
        const res = await fetch(address + `/api/${person}/info`)
        const data = await res.json()
        setTutorInfo(data.tutor)
    }
    getTutorInfo()
    const getRequests = async () => {
      const res = await fetch(`${address}/api/${user.nickname}/sentRequests`)
      const data = await res.json()
      for(let tutors of data.sentRequests) {
        if(tutors.requestedUser === person) {
          setRequest(true)
        }
      }
    }
    getRequests()
  }, [user, person])

    useEffect(() => {

        const getMessages = () => {
          socket.on("message", msg => {
      
            setMessages([...messages, msg]);
          });
        };
    
    
      
      socket.on('join')
        getMessages()
      
      }, [messages, message])

      const onChange = e => {
        setMessage(e.target.value);
      };


      
      const requestJoin = async (status, tutorName) => {
        const requestOptions = {
          method: 'POST',
          headers: {
            'content-type': 'application/json' },
          body: JSON.stringify({ tutorName: tutorName, studentName: user.nickname })
        };
          await fetch(address + '/api/requestTutor', requestOptions)
          //setRequest(!requested)
          setRequest(true)
      }

      const sendMail = (tutorName) => {
        requestJoin('requested', tutorName)
      const tempVars = {
        to_email: tutorInfo.email,
        to_name: tutorInfo.fullName.length > 1 ? tutorInfo.fullName : tutorInfo.name,
        reply_to: user.email,
        from_name: name.length > 1 ? name : user.nickname,
      }
      
      window.emailjs.send(
        process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID,
          tempVars
          ).then(() => {
          })
          // Handle errors here however you like, or use a React error boundary
          .catch(() => alert('Sorry, there was an error when sending your email'))
      }

      const handleSubmit = (event) => {
        event.preventDefault()
        if (message !== "") {
          // 
          socket.emit('join', {message: user.nickname + ": " + message, room: user.nickname+person})
           setMessage("");
         } else {
           alert("Please Add A Message");
         }
      }

      const rightText = (text) => {
        const wordStyle = {
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        wordBreak: 'break-all',
        hyphens: 'auto',
  }
      if(text === 'Chat Help'){
        return(
          <div className="level-item">
          <p className="has-text-danger">
            {text}
          </p>
          </div>
        )
      } else {
        const name = text.indexOf(": ")
        const strippedText = text.substring(name+1)
        const sender = text.substring(0, name)
        return(
        <div style={{paddingLeft: '1%'}}>
          <b>
            {sender}
          </b>
          <p style={wordStyle}>
            {strippedText}
          </p>
        </div>
        )
      }
    }

    if (isLoading) {
      return <div>Loading ...</div>;
      }
    
    return (
      isAuthenticated && (
        <div>
			<div className="heroContainer">
				<h1>{tutorInfo.fullName}</h1>
        <h2>Email: {tutorInfo.email}</h2>
          <p>{tutorInfo.bio}</p>
          Available to teach...
          <div className="level-item" style={{paddingBottom: '1.5%'}}>
          {tutorInfo['virtual'] && <p className="has-text-weight-bold">Virtually</p>}
          {tutorInfo['inPerson'] && <p className="has-text-weight-bold" style={{paddingLeft: '5%'}}> In perosn</p>}
          </div>
        {!requested && <button className="blueBtn" style={{backgroundColor: '#0077ff', color: 'white'}} onClick={() => sendMail(person)}>Send Email</button>}
        {requested && <button className="blueBtn" onClick={() => alert('You already sent a request!')}>Email sent</button>}
        <br/>
        <Link className="link" to={ {
          pathname: `/${person}/reviews`}}>Look at reviews for {person}</Link>
			</div>
			<div className="chatOptions">
				<div className="chatVideo">
					<h2>Video Call</h2>
					<VideoChat person={person}/>
				</div>
				<div className="chatOther">
					<h2>Text Chat</h2>
                	<form onSubmit={handleSubmit}>
						<input value={message} placeholder="Send Message" name="message" className="tealTextInput" onChange={e => onChange(e)} />
					</form>
					{messages.length > 0 &&
						messages.map((msg,i) => (
						<ul key={i}>
							<li key={i}>
							<div key={i}>
							{rightText(msg)}
							</div>
							</li>
						</ul>
					))}
				</div>
			</div>

    </div>
      )
    )
}

export default Chat